import { RouteContextWrapper } from "@/components/custom/providers/routeContextWrapper";

export default function SettingsUserPage() {
  return (
    <RouteContextWrapper
      resolvedParams={{ caseId: "default" }}
      resolvedSearchParams={{}}
      settingsView="user"
    />
  );
}
